import CalenderImg from '../assets/images/calender.png';
import DashboardCard from '../layouts/DashboardCard';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { app } from '../config';
import getHeaders from '../utils/authHeaders';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import InputMask from 'react-input-mask';
import { Button, Col, Form, Input, Pagination, Row, DatePicker, Select, Modal as AntModal, message, Switch } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import logo from '../assets/images/image.png';
// import fetchOrderDetails from '../hooks/fetchOrderDetails';
import NoDataFound from '../layouts/NoDataFound';
import { SearchBar } from '../layouts/SearchBar';
import LoaderImage from './LoaderImage';
import RadarChart from './RadarChart';
import { Cardiology } from './Cardiology';
import { TableAntDesign } from './TableAntDesign';
import { durationSelection, onChangeMethod } from '../utils/SortingUtils';
import TestOrderDetailModal from './TestOrderDetailModal';
import { BsReverseLayoutTextWindowReverse } from 'react-icons/bs';


// import { Table } from 'reactstrap';
import momentT from 'moment-timezone';
import { InputField, SelectField } from '../layouts/FormFields';
import QuestionaireModal from './QuestionaireModal';
import { getSerial } from '../utils/getSerial';
import ErrorModal from './ErrorModal';
const Dashboard2 = () => {
  const [activeIndex, setActiveIndex] = useState(1);
  const [refreshView, setRefreshView] = useState(false);
  const [count, setCount] = useState();
  const [activatedCount, setActivatedCount] = useState();
  const [awatingCount, setawatingCount] = useState();
  const [completeCount, setCompletedCount] = useState();
  const [errorCount, seterrorCount] = useState();

  const [renderList, setRenderList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchShow, setSearchShow] = useState({});
  const [pagin, setpagin] = useState({});
  const [filterObj, setfilterObj] = useState({});
const [showisFilter,setshowisFilter]=useState(true)
  const [tableHeaders, setTableHeaders] = useState([]);
  const [tableShow, setTableShow] = useState(false);
  const [show, setShow] = useState(false);  
  const [err, setErr] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [orderDetails, setOrderDetails] = useState(null);
  const [uploadObj, setUploadObj] = useState({});
  const [searchValue, setSearchValue] = useState('');
  const [searchType, setSearchType] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [orderDateFrom, setorderDateFrom] = useState('');
  const [orderDateTo, setorderDateTo] = useState('');
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [testOrderDetails, setTestOrderDetails] = useState({});
  const[isSearch,setisSearch]=useState(false)
  const [isVisible, setIsVisible] = useState(false);
  const [showQuestion, setshowQuestion] = useState(false)
 const [modalData, setmodalData] = useState(false);
  const [searchByValue, setSearchByValue] = useState('');
   const [isEncrypt, setisEncrypt] = useState(false);
 const [serialvalue,setSerialValue]=useState("")
  const [showerrorMOdal, setshowerrorMOdal] = useState(false)
const [error, seterror] = useState("");
  
  console.log(app.URL);
//   const showModal = async (orderNo) => {
//     console.log('Show modal Running');
//     const fetchReportdata = await axios.get(`${app.URL}/api/v1/app/testresult/createallpdfs?orderNo=${orderNo}&type=single`, { headers: getHeaders() });
// // let pdfUrl = 'https://hccl-know.s3.amazonaws.com/testresult-pdf/b1277f4e-714c-401f-804e-982bff752759';

// //     window.open(pdfUrl, '_blank');
//       // const fetchReportdata = await axios.get(`http://localhost:3200/api/v1/app/testresult/createallpdfs?orderNo=${orderNo}&type=single`, { headers: getHeaders() });
    
//     console.log(fetchReportdata);
//    if (fetchReportdata.status == 200) {
//     //  const pdfUrl = fetchReportdata?.data?.data; // Assuming the URL is in this path

//      if (fetchReportdata?.data?.data) {
//        console.log('pdfUrl', fetchReportdata?.data?.data);
//        // Open the PDF in a new tab
//        window.open(fetchReportdata?.data?.data , '_blank');
//      } else {
//        console.log('No URL found in the response');
//      }
//    }
//   };
  
  const questionaireModal = async (testOrderId) => {
    try {
      let resp = await axios.get(`${app.URL}/api/v1/admin/dashboard/questionnaire/${testOrderId}`, { headers: getHeaders() });
      // let resp = {
      //   status : 200,
      //   data: {
      //     result: {
      //       type: 'Success',
      //       success: true,
      //       code: 200,
      //       msg: 'Questions fetched successfully.',
      //       data: [
      //         {
      //           id: 13874,
      //           question: 'When was the last time you had a colon screening?',
      //           answer: 'haven’t had one. ',
      //         },
      //         {
      //           id: 13875,
      //           question: 'What was your main reason for purchasing this test? ',
      //           answer: 'testing purposes. ',
      //         },
      //       ],
      //     },
      //   }
      // };
      console.log("resp", resp)
      if (resp.status = 200) {
        setmodalData(resp?.data?.result?.data)
        setshowQuestion(true);


      }
      
    } catch (error) {
      console.log("error",error)
    }
  }
  console.log("modaldata",modalData)
  
  const showModalold = async (orderNo,isReport) => {
    console.log('Show modal Running');

    try {
      // const fetchReportdata = await axios.get(`${app.URL}/api/v1/app/testresult/createallpdfs?orderNo=${orderNo}&type=single`, { headers: getHeaders() });
      const fetchReportdata = await axios.get(`${app.URL}/api/v1/app/testresult/viewpdf/${orderNo}`, { headers: getHeaders() });
      // const fetchReportdata = await axios.get(`http://localhost:3200/api/v1/app/testresult/viewpdf/${orderNo}`, { headers: getHeaders() });
     
      console.log(fetchReportdata);

      // Check if the status is 200 and the data URL exists
      if (fetchReportdata.status === 200) {
        const pdfUrl = isReport ? fetchReportdata?.data?.docPdf: fetchReportdata?.data?.data;
        if (pdfUrl) {
          console.log('PDF URL:', pdfUrl);

          // Ensure URL is valid and open it
          window.open(pdfUrl, '_blank');
        } else {
          console.log('No URL found in the response');
        }
      }
    } catch (error) {
      console.error('Error fetching report:', error);
    }
  };
    const showModal = async (orderNo, isReport) => {
      console.log('Show modal Running');

      try {
        // const fetchReportdata = await axios.get(`${app.URL}/api/v1/app/testresult/createallpdfs?orderNo=${orderNo}&type=single`, { headers: getHeaders() });
        const fetchReportdata = await axios.get(`${app.URL}/api/v1/app/testresult/viewpdf/${orderNo}`, { headers: getHeaders() });
        // const fetchReportdata = await axios.get(`http://localhost:3200/api/v1/app/testresult/viewpdf/${orderNo}`, { headers: getHeaders() });

        console.log(fetchReportdata);

        // Check if the status is 200 and the data URL exists
        if (fetchReportdata.status === 200) {
          const pdfUrl = isReport ? fetchReportdata?.data?.docPdf : fetchReportdata?.data?.data;
          if (pdfUrl) {
            console.log('PDF URL:', pdfUrl);
            if (fetchReportdata?.data?.data){
              // Ensure URL is valid and open it
              window.open(pdfUrl, '_blank');}
          
            
          } else {
            console.log('No URL found in the response');
          }
        }
      } catch (error) {
        console.error('Error fetching report:', error);
      }
    };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleClose = () => setShow(false);
  const { RangePicker } = DatePicker;
  let activatedProdHeaders = ['Order No.', 'Customer', 'Product', 'Activation Date & Time', 'Collection Date & Time', 'Serial No.', 'Action'];
  let awaitingResultHeaders = ['Order No.', 'Customer Name', 'Accession No', 'Product Name', 'CIS Name', 'Send to Lab', 'Action'];
  let completed = ['Order No.', 'Customer Name', 'Accession No', 'Product Name', 'CIS Code', 'CIS Name', 'Completion Date', 'Action'];
  let rejected = ['Order No.', 'Customer Name', 'CIS Name', 'File Name', 'Date Rejected',"Action"];

  let headersMap = new Map();
  headersMap.set(1, activatedProdHeaders);
  headersMap.set(2, awaitingResultHeaders);
  headersMap.set(3, completed);
  headersMap.set(4, rejected);
  

  const loginUserObj = JSON.parse(localStorage.getItem('user'));
  let userObj = loginUserObj ? loginUserObj.result.data.user : {};

  const uploadData = async (orderObj, orderDetails) => {
    try {
      // console.log('Order Object: ');
      // console.log(orderObj);
      // console.log('orderDetails: ');
      // console.log(orderDetails);
      const res = await axios.post(`${app.URL}/api/v1/admin/dashboard/sendtolab/${orderObj.testOrderId}`, { ...orderObj, ...orderDetails, ...{ adminUserId: userObj.userId } }, { headers: getHeaders() });
      console.log(res);
    } catch (err) {
      console.log(err);
      if (err) console.log(err.response.data.message);
      else return;
    }
  };

  const handleChange = (event) => {
    setPhoneNumber(event.target.value);
    // handle phone number input here
  };

  const setRender = (data) => {
    setLoading(false);
    setRenderList(data);
  };

  const dashboardListingApi = async (formData,index) => {
    console.log(formData);
    console.log('searchshow', searchShow);

    console.log(formData);
    // console.log('isSearch,isSearch', isSearch);

    // if (isSearch) {
    //   formData.searchBy = pagin.searchBy;
    //   formData.searchTxt = pagin.searchTxt;
      // setCurrentPage(1);
    // } 
    // console.log("data here is : ",formData);
    
    setLoading(true);
    const resp = await axios.post(`${app.URL}/api/v1/admin/dashboard/listing`, formData, { headers: getHeaders() });
    // const resp = await axios.post(`http://localhost:3200/api/v1/admin/dashboard/listing`, formData, { headers: getHeaders() });

    // console.log(resp);
    // roleResp.data ? setFetchedRoles(roleResp.data.result.data) : ' ';
    resp.data  ? setCount(resp.data.result.data.count) : ' ';
    // resp.data ? setCurrentPage(1) : ' ';
    resp.data  ? setRender(resp.data.result.data.data) : ' ';

    // new additions
    resp.data ? setActivatedCount(resp.data.result.data.status[0].count) : ' ';
    resp.data ? setawatingCount(resp.data.result.data.status[1].count) : ' ';
    resp.data ? setCompletedCount(resp.data.result.data.status[2].count) : ' '; 
    resp.data ? seterrorCount(resp.data.result.data.status[3].count) : ' '; 

    // req.body.index && req.body.index == 4 ? resp.length : 
    // if (index && index == 4) {
    //   await callTestErrors()
    // }
    // resp.data ? setCurrentPage(1) : ' ';
  };

  const getTestOrderDetail = async (testOrderId) => {
    // const res = await axios.get(`http://localhost:3200/api/v1/admin/dashboard/view/${testOrderId}?isTestorder=1`, { headers: getHeaders() });
    const res = await axios.get(`${app.URL}/api/v1/admin/dashboard/view/${testOrderId}?isTestorder=1`, { headers: getHeaders() });

    // const res = await axios.get(`${app.URL}/api/v1/admin/dashboard/view/${testOrderId}?isTestorder=1`, { headers: getHeaders() });
    // console.log(res.data.result.data);

    res.data && setTestOrderDetails(res.data.result.data);
    res.data && setIsVisible(true);
  };

  const activatedProductRows = (tableData) => {
    return (
      <>
        {/* <td>{tableDate.testOrderId ? tableDate.testOrderId : 'null'}</td> */}
        <td>{tableData.orderNo ? tableData.orderNo : 'null'}</td>
        <td>{tableData.patientName ? tableData.patientName : 'null'}</td>
        {/* <td>{tableData.partnerName ? tableData.partnerName : 'null'}</td> */}
        <td>{tableData.productName ? tableData.productName : 'null'}</td>
        <td>{tableData.orderDate ? moment(tableData.orderDate).format('MM-DD-YYYY HH:mm') : '-'}</td>
        <td>{tableData.collectionTime ? moment(tableData.collectionTime).format('MM-DD-YYYY HH:mm') : '-'}</td>
        <td>{tableData.serialNo ? tableData.serialNo : 'null'}</td>
        <td>
          <button className='btn text-light p-2' style={{ width: '40px', height: '36px' }} onClick={() => questionaireModal(tableData?.testOrderId)} title='Open Questionnaire'>
            <BsReverseLayoutTextWindowReverse size={20} />
          </button>
          <button className='btn text-light mx-2' onClick={() => getTestOrderDetail(tableData.testOrderId)}>
            View
          </button>
          {/* <button className='btn text-light p-2' style={{ padding: '2px' }} onClick={() => questionaireModal(tableData?.testOrderId)}>
            <BsReverseLayoutTextWindowReverse />
          </button> */}
        </td>
      </>
    );
  };

  const awaitngProductRows = (tableData) => {
    // console.log(tableData);
    return (
      <>
        {/* <td>{tableDate.testOrderId ? tableDate.testOrderId : 'null'}</td> */}
        <td>{tableData.orderNo ? tableData.orderNo : 'null'}</td>
        <td>{tableData.patientName ? tableData.patientName : 'null'}</td>
        <td>{tableData.accessionNo ? tableData.accessionNo : 'null'}</td>
        <td>{tableData.productName ? tableData.productName : 'null'}</td>
        {/* <td>{tableData.cisPanelCode ? tableData.cisPanelCode : 'null'}</td> */}
        <td>{tableData.cisPanelName ? tableData.cisPanelName : 'null'}</td>
        {/* <td>{tableData.isActive === '1' ? 'Active' : 'Inactive'}</td> */}
        <td>{tableData.sendToLabDateTime ? moment(tableData.sendToLabDateTime).format('MM-DD-YYYY HH:mm') : 'null'}</td>
        <td>
          <button className='btn text-light p-2' style={{ width: '40px', height: '36px' }} onClick={() => questionaireModal(tableData?.testOrderId)} title='Open Questionnaire'>
            <BsReverseLayoutTextWindowReverse size={20} />
          </button>
          <button className='btn text-light mx-2' onClick={() => getTestOrderDetail(tableData.testOrderId)}>
            View
          </button>
          {/* <button className='btn text-light p-2' style={{ padding: '2px' }} onClick={() => questionaireModal(tableData?.testOrderId)}>
            <BsReverseLayoutTextWindowReverse />
          </button> */}
        </td>
      </>
    );
  };

  const displayPSTDate = (datetime) => {
    if (datetime) {
      datetime = datetime.replace('Z', '-07:00');
      console.log(datetime);
      // Parse the input and set the timezone to PST
      const pstDate = momentT.tz(datetime, 'America/Los_Angeles');
      return pstDate.format('MM/DD/YYYY HH:mm A z'); // 24-hour time format
    }
    return null;
  };

 const NewdisplayPSTDate = (datetime) => {
    if (datetime) {
      let userTimezone = moment.tz.guess();
      return moment(datetime).tz(userTimezone).format('MM-DD-YYYY hh:mm A z');
      // return momentT(date).tz('America/Los_Angeles').format('MM/DD/YYYY hh:mm A z');
    }
    return null;
  };
  const NewdisplayPSTDates = (datetime) => {
    if (datetime) {
      let userTimezone = moment.tz.guess();
      return moment(datetime).tz(userTimezone).format('MM-DD-YYYY HH:mm ');
      // return momentT(date).tz('America/Los_Angeles').format('MM/DD/YYYY hh:mm A z');
    }
    return null;
  };
// const displayPSTDate = (datetime) => {
//   if (datetime) {
//     const cleanDateTime = datetime.replace('Z', '');
//     const laTime = moment.tz(cleanDateTime, 'America/Los_Angeles');


//     // const userTimezone = moment.tz.guess();
//     // console.log('userTimezone', userTimezone);
//     // const abbreviation = moment.tz(userTimezone).format('z');
//     // Convert to UTC and return as ISO string
//     const utcTime = laTime.utc().format(); // OR use .toISOString();
//     return moment(utcTime).format('MM-DD-YYYY HH:mm A ');
//     // return { date: moment(utcTime).format('MM-DD-YYYY hh:mm A '), tzone: userTimezone };


//   }
//   return null;
//   };
//  const AimandisplayPSTDate = (datetime) => {
//   if (datetime) {
//     const cleanDateTime = datetime.replace('Z', '');
//     const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
 
//     const localTime = moment.utc(cleanDateTime).tz(userTimeZone);
//    console.log(cleanDateTime);
//     // Parse the input and set the timezone to PST
//     // const pstDate = moment.tz(datetime, "America/Los_Angeles");
//     return localTime.format('MM/DD/YYYY hh:mm A z');
//   }
//   return null;
// };
  // export const displayPSTDate = (datetime) => {
  //   if (datetime) {
  //     // datetime = datetime.replace("Z", "-08:00");
  //     const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  //     console.log('user time zone', userTimeZone);
  //     console.log('ZONE', datetime, moment.tz(datetime, 'Asia/Karachi'));

  //     const localTime = moment.utc(datetime).tz(userTimeZone);
  //     console.log(localTime.format('MM/DD/YYYY hh:mm A z'));
  //     console.log(datetime);
  //     // Parse the input and set the timezone to PST
  //     // const pstDate = moment.tz(datetime, "America/Los_Angeles");
  //     return localTime.format('MM/DD/YYYY hh:mm A z');
  //   }
  //   return null;
  // };
  // const displayPSTDate = (datetime) => {
  //   if (datetime) {
  //     // datetime = datetime.replace('Z', '-08:00');
  //     // const rawTime = '2025-07-03T16:16:00'; // LA local time from server
  //     const laTime = moment.tz(datetime, 'America/Los_Angeles');
  //     const userTime = laTime.local();
  //     return userTime.format('MM-DD-YYYY hh:mm');
  //     // // Parse the input and set the timezone to PST
  //     // const pstDate = momentT.tz(datetime, 'America/Los_Angeles');
  //     // return pstDate.format('MM/DD/YYYY hh:mm A z'); // 24-hour time format
  //   }
  //   return null;
  // };


  // this is old
// const dateTimeFormatWithTimeZone = (date) => {
//   // var dec = moment("2014-12-01T12:00:00Z");
//   // Format date in MM/DD/YYYY HH:mm with AM/PM and PST timezone

//   if (date) {
//     let userTimezone = moment.tz.guess();
//     return momentT(date).tz('America/Los_Angeles').format('MM/DD/YYYY hh:mm A z'); 
//     // return momentT(date)
//     //   .tz('America / Los_Angeles')
//     //   .format('MM/DD/YYYY hh:mm A z');
//   } else {
//     return '- - -';
//   }
// };
  const completedProductRows = (tableData) => {
    // console.log(tableData);
    return (
      <>
        {/* <td>{tableDate.testOrderId ? tableDate.testOrderId : 'null'}</td> */}
        <td>{tableData.orderNo ? tableData.orderNo : 'null'}</td>
        <td>{tableData.patientName ? tableData.patientName : 'null'}</td>
        <td>{tableData.accessionNo ? tableData.accessionNo : 'null'}</td>
        <td>{tableData.productName ? tableData.productName : 'null'}</td>
        <td>{tableData.cisPanelCode ? tableData.cisPanelCode : 'null'}</td>
        <td>{tableData.cisPanelName ? tableData.cisPanelName : 'null'}</td>
        {/* <td>{tableData.isActive === '1' ? 'Active' : 'Inactive'}</td> */}
        {/* <td>{tableData.orderDate ? moment(tableData.orderDate).format('MM-DD-YYYY HH:mm') : 'null'}</td> */}
        <td>{tableData?.resultsReportedStatusChanged ? NewdisplayPSTDate(tableData.resultsReportedStatusChanged) : 'null'}</td>
        {/* <td>{tableData?.resultsReportedStatusChanged ? moment(tableData.resultsReportedStatusChanged).format('MM-DD-YYYY HH:mm ') : 'null'}</td> */}
        {/* <td>
          {tableData?.resultsReportedStatusChanged
            ? moment(tableData.resultsReportedStatusChanged).tz('America/Los_Angeles').format('MM-DD-YYYY hh:mm A z') // 'z' adds PDT or PST
            : 'null'}
        </td> */}

        <td className='d-flex gap-2 align-items-center'>
          <button type='button' className='btn btn-primary' style={{ fontSize: '12px' }} onClick={() => showModal(tableData.orderNo, true)}>
            D_Report
          </button>

          <button type='button' className='btn btn-primary' style={{ fontSize: '12px' }} onClick={() => showModal(tableData.orderNo)}>
            P_Report
          </button>
          <button className='btn btn-primary d-flex justify-content-center align-items-center p-2' style={{ width: '40px', height: '36px' }} onClick={() => questionaireModal(tableData?.testOrderId)} title='Open Questionnaire'>
            <BsReverseLayoutTextWindowReverse size={20} />
          </button>
          <button className='btn btn-secondary text-light' style={{ fontSize: '12px' }} onClick={() => getTestOrderDetail(tableData.testOrderId)}>
            View
          </button>
        </td>
      </>
    );
  };

  const formatName = (name) => {
    if (!name) return 'null';
    return name.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()); // capitalizes first letter of each word
  };


  const errorListingRows = (tableData) => {
    // console.log(tableData);
    return (
      <>
        <td>{tableData.orderNo ? tableData.orderNo : 'null'}</td>
        <td>{tableData.patientName ? formatName(tableData.patientName) : 'null'}</td>
        <td>{tableData.cisPanelName ? tableData.cisPanelName : 'null'}</td>
        <td>{tableData.fileName ? tableData.fileName : 'null'}</td>

        <td>{tableData.rejectedAt ? moment(tableData.rejectedAt).format('YYYY-MM-DD HH:mm:ss') : 'null'}</td>
        {tableData?.error ? <button className='btn btn-secondary text-light' style={{ fontSize: '12px' }} onClick={() => {
          setshowerrorMOdal(true)
          seterror(tableData.error);
      }}>
          View
        </button>:<p></p>
        
        }
      </>
    );
  };

  useEffect(() => {
    let formData = {
      limit: 10,
      offset: 0,
      searchBy: 'productName', //partnerName, serialNo, orderNo
      searchTxt: '',
      status: activeIndex, //1 = In-Transit (Inprogress), 2 = Sent to Lab, 3 = Completed
      orderDateFrom: '', //2023-03-03  only give date without time
      orderDateTo: '',
      filterBy: '',
      filterParam: '',
    };
    dashboardListingApi(formData);
    setTableHeaders(headersMap.get(activeIndex));
    // return () => {};
  }, []);
console.log('currentPagecurrentPage', currentPage);

  const handleQRbarCode = async(e) => {
    const word = e.target.value.trim();
    let serial = ""

    console.log('word', word);

    if (word.length === 13) {
     
      
      setisEncrypt(true);
    
serial = await getSerial(word);
if (serial) {
  setSerialValue(serial);

  handleSerialNoChange({ target: { value: serial } });
} else {
  setSerialValue('');
}
setisEncrypt(false);
    
      

      //  handleSerialNoChange(e);
    }

    if (word.length === 21 && word.toLowerCase().startsWith('kus-')) {
      console.log('Valid 6-char code starting with KUS-:', word);
      handleSerialNoChange(e);

      // Do something with the code
    }
  };

   const handleSerialNoChange = async (event) => {
     console.log('handleSerialNoChange', event.target.value);

     
     if (event.target.value.length === 21) {
   
      onSearchFinish({ searchBy: searchByValue, searchTxt: event.target.value });
     }
     // if (event.target.value.length === 13) {
     //   await checkOrderBySerialNo('G', event.target.value);
     // }
   };
const handleOnChange = async (e) => {
  console.log('Search input changed:', e.target.value);
  console.log('Search input changed:', e.target.value.length);

   if (searchByValue === 'serialNo') {
  setSerialValue(e.target.value);
     handleQRbarCode(e);
   }

  if (!e || !e.target || e.target.value === undefined) {
    console.error('Invalid event in handleOnChange');
    return;
  }

//   if (e.target.value.length == 1) {
//     setisSearch(false);
  
// }
  if (e.target.value.length == 0) {
    console.log('o length');
    // setisSearch(false);
    let formData = {
      limit: 10,
      offset: 0,
      searchBy: 'productName',
      searchTxt: '',
      status: activeIndex,
      orderDateFrom: orderDateFrom ? orderDateFrom : '',
      orderDateTo: orderDateTo ? orderDateTo : '',
      filterBy: filterObj?.filterBy ? filterObj?.filterBy : '',
      filterParam: filterObj?.filterParam ? filterObj?.filterParam : '',
    };
    setSearchShow({});
          setCurrentPage(1);
    // setisSearch(false)
    // setfilterObj({})
    await dashboardListingApi(formData);
  }
};

    console.log('isSearch after change,', isSearch);

  const dashboardListingApiforCount = async (formData) => {
    console.log(formData);
//  setShow({
//    searchBy: formData.searchBy,
//    searchTxt: formData.searchTxt,
//  });
    const apiResp = await axios.post(`${app.URL}/api/v1/admin/dashboard/listing`, formData, { headers: getHeaders() });
    // const apiResp = await axios.post(`http://localhost:3200/api/v1/admin/dashboard/listing`, formData, { headers: getHeaders() });

    console.log(apiResp);
    // apiResp ? console.log(apiResp.data.result.data.count) : ' ';
    // apiResp.data && formData.status == 1 ? setActivatedCount(apiResp.data.result.data.status[0].count) : ' ';
    // apiResp.data && formData.status == 2 ? setawatingCount(apiResp.data.result.data.status[1].count) : ' ';
    // apiResp.data && formData.status == 3 ? setCompletedCount(apiResp.data.result.data.status[2].count) : ' ';
    // apiResp.data  ? setCurrentPage(1) : ' ';
    apiResp ? console.log(apiResp.data.result.data.count) : ' ';
    apiResp.data  ? setActivatedCount(apiResp.data.result.data.status[0].count) : ' ';
    apiResp.data  ? setawatingCount(apiResp.data.result.data.status[1].count) : ' ';
    apiResp.data ? setCompletedCount(apiResp.data.result.data.status[2].count) : ' ';
    apiResp.data ? seterrorCount(apiResp.data.result.data.status[3].count) : ' ';

    apiResp.data ? setCurrentPage(1) : ' ';
    // apiResp.data ? setFetchedRoles(apiResp.data.result.data) : ' ';
  };

  const onFinish = (values) => {
    console.log('Success:', values);

    setUploadObj({
      comments: values.instructions ? values.instructions : null,
    });
    setShow(true);
  };

  const onSearchFinish = async (values) => {
    console.log('onSearchFinish');
   
    console.log('Success:', values);
    let formData = {
      limit: 10,
      offset: 0,
      searchBy: values.searchBy, //partnerName, serialNo, orderNo
      searchTxt: values.searchTxt,
      status: activeIndex, //1 = In-Transit (Inprogress), 2 = Sent to Lab, 3 = Completed
      orderDateFrom: orderDateFrom ? orderDateFrom : '', //2023-03-03  only give date without time
      orderDateTo: orderDateTo ? orderDateTo : '',
      filterBy: values?.filterBy ? values.filterBy : '',
      filterParam: values?.filterParam ? values.filterParam : '',
    };
    if (formData.searchTxt) {
      console.log('formData.searchTxt', formData.searchTxt);

      // setisSearch(true)
      setSearchShow({ searchFor: formData.searchBy, searchItem: formData.searchTxt });
    }
    // setSearchShow({ searchBy: values.searchBy, searchTxt: values.searchTxt });
    if (!values.searchTxt && !values.filterParam) message.error('Please enter search text');
    // console.log(formData)
    else {
      await dashboardListingApi(formData); 
      setCurrentPage(1)
      if(searchByValue === "serialNo"){
        setSerialValue("")
      }
    }
  };
  console.log(currentPage)

  const onSearchFinishFailed = (values) => {
    console.log('Failed:', values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const submitData = (orderObj) => {
    console.log('submit data calling');
    if (Object.keys(uploadObj).length > 0) {
      uploadData(orderObj, uploadObj);
    }
  };
  



  // useEffect(() => {
  //   // const countAPI = async () => {
  //   //   for (let i = 1; i < 4; i++) {
  //   //     let formData1 = {
  //   //       limit: 10,
  //   //       offset: 0,
  //   //       searchBy: 'productName', //partnerName, serialNo, orderNo
  //   //       searchTxt: '',
  //   //       status: i, //1 = In-Transit (Inprogress), 2 = Sent to Lab, 3 = Completed
  //   //       orderDateFrom: '', //2023-03-03  only give date without time
  //   //       orderDateTo: '',
  //   //       filterBy: '',
  //   //       filterParam: '',
  //   //     };
  //   //     const activatedCount = await dashboardListingApiforCount(formData1);
  //   //     console.log(activatedCount);
  //   //   }
  //   // };
  //   const countAPI = async () => {
  //     for (let i = 1; i < 4; i++) {
  //       let formData1 = {
  //         limit: 10,
  //         offset: 0,
  //         searchBy: 'productName', //partnerName, serialNo, orderNo
  //         searchTxt: '',
  //         status: activeIndex, //1 = In-Transit (Inprogress), 2 = Sent to Lab, 3 = Completed
  //         orderDateFrom: '', //2023-03-03  only give date without time
  //         orderDateTo: '',
  //         filterBy: '',
  //         filterParam: '',
  //       };
  //       const activatedCount = await dashboardListingApiforCount(formData1);
  //       console.log(activatedCount);
  //     }
  //   };
  //   countAPI();
  // }, []);




  console.log('activatedIndex', activeIndex);
  //
  
    console.log('filterObj', filterObj);
  
  const onPageChange = async (page, pageSize) => {
    console.log('pagepage h', currentPage);

    console.log('pagepage ', page);
    console.log('pageSizepageSize', pageSize);
    console.log('searchShow', searchShow);

    if (!page) page = 1;

    setPageSize(pageSize);
    setCurrentPage(page);
   if(!page) setCurrentPage(1);

    let limit = pageSize;
    try {
      let reqObj;
      if (Object.keys(searchShow).length !== 0) {
        reqObj = {
          limit: limit,
          offset: limit * (page - 1),
          status: activeIndex,
          searchBy: searchShow.searchFor,
          searchTxt: searchShow.searchItem,
          orderDateFrom: orderDateFrom ? orderDateFrom : '', //2023-03-03  only give date without time
          orderDateTo: orderDateTo ? orderDateTo : '',
          filterBy: filterObj?.filterBy ? filterObj?.filterBy :'' ,
          filterParam: filterObj?.filterParam ? filterObj?.filterParam:'',
        };
      } else {
        reqObj = {
          limit: limit,
          offset: limit * (page - 1),
          status: activeIndex,
          searchBy: 'productName',
          searchTxt: '',
          orderDateFrom: orderDateFrom ? orderDateFrom : '', //2023-03-03  only give date without time
          orderDateTo: orderDateTo ? orderDateTo : '',
          filterBy: filterObj?.filterBy ? filterObj?.filterBy : '',
          filterParam: filterObj?.filterParam ? filterObj?.filterParam : '',
        };
      }
      console.log(reqObj);
      await dashboardListingApi(reqObj);
    } catch (e) {
      console.log('Error');
      console.log(e);
      if (e.message) setErr(e.message);
      setTableShow(false);
    }
  };



  // const onDateFilter = async (index,obj) => {
  //   // setTableHeaders(headersMap.get(index))
  //   // setCount('')

  // }
  const durationSelect = async (value) => {
    console.log('value ', value);
    durationSelection(dashboardListingApi, value, setorderDateFrom, setorderDateTo, activeIndex, searchShow, 10, 0, 'productName');
  };
  const onChange = async (date, dateString) => {
    console.log(date, dateString);
    onChangeMethod(dashboardListingApi, dateString, setorderDateFrom, setorderDateTo, activeIndex, searchShow, pageSize, pageSize * (currentPage - 1), 'productName');
  };
  const onCardClick = async (index) => {
    setActiveIndex(index);

    console.log('active Index ', index);
    setTableHeaders(headersMap.get(index));
    console.log(headersMap.get(index));
    setCount('');
    setRenderList([]);


    // if (index === 4) {
    //   return; // Skip API call for Rejected section if no data should be displayed
    // }

    let formData = {
      limit: 10,
      offset: 0,
      searchBy: 'productName', //partnerName, serialNo, orderNo
      searchTxt: '',
      status: index, //1 = In-Transit (Inprogress), 2 = Sent to Lab, 3 = Completed
      orderDateFrom: '', //2023-03-03  only give date without time
      orderDateTo: '',
      filterBy: '',
      filterParam: '',
      index: index && index == 4 ? 4 : '',
    };
    await dashboardListingApi(formData);
  };

  const ActivatedItem = [
    {
      value: 'productName',
      name: 'Product',
    },
    // {
    //   value: 'partnerName',
    //   name: 'Partner',
    // },
    {
      value: 'serialNo',
      name: 'Serial No.',
    },
    {
      value: 'orderNo',
      name: 'Order No.',
    },
    {
      value: 'customerName',
      name: 'Customer Name',
    },
    {
      value: 'collectionDate',
      name: 'Collection Date',
    },
  ];

  const AwaitingItem = [
    {
      value: 'productName',
      name: 'Product',
    },
    {
      value: 'orderNo',
      name: 'Order No.',
    },
    {
      value: 'accessionNo',
      name: 'Accession No.',
    },
    {
      value: 'cisPanelCode',
      name: 'CIS Code',
    },
    {
      value: 'customerName',
      name: 'Customer Name',
    },
  ];
// console.log('filterobj', fiterObj);

  return (
    <>
      {showerrorMOdal && <ErrorModal error={error} isVisible={showerrorMOdal} setIsVisible={setshowerrorMOdal} seterror={seterror} />}

      {showQuestion && modalData && <QuestionaireModal data={modalData} modalOpen={showQuestion} setModalOpen={setshowQuestion} />}
      <div className='dashboard-card container-fluid'>
        <div className='row p-0 pb-4'>
          <div className='for-before col-12 col-lg-4 col-md-6 head fs-3 fw-bold' style={{ backgroundColor: '#a7c1d9', borderBottomRightRadius: '10px', color: '#FFFFFF' }}>
            Dashboard
          </div>
          <div className='col-12 mt-2 col-lg-4 col-md-3'>
            <RangePicker onChange={onChange} />
          </div>
          <TestOrderDetailModal isVisible={isVisible} setIsVisible={setIsVisible} testOrderDetails={testOrderDetails} displayPSTDate={NewdisplayPSTDate} dateTimeFormatWithTimeZone={NewdisplayPSTDates} isTestOrder={true} />
          <div className='col-12 mt-2 col-lg-4 col-md-3' style={{ position: 'relative' }}>
            <img className='calender-img' src={CalenderImg} />
            <select className='form-control drop-down-select' name='dates' id='date' onChange={(e) => durationSelect(e.target.value)}>
              <option value={moment().subtract(24, 'hours').format('YYYY-MM-DD')}>last 24 hours</option>
              <option value={moment().subtract(7, 'd').format('YYYY-MM-DD')}>last week</option>
              <option value={moment().subtract(1, 'months').format('YYYY-MM-DD')}>last month</option>
              <option value={moment().subtract(1, 'year').format('YYYY-MM-DD')}>last year</option>
            </select>
          </div>
        </div>
        <div className='row px-3'>
          <div style={{ position: 'relative' }} className='col-3 my-1' onClick={() => onCardClick(1)}>
            <DashboardCard count={activatedCount} isActive={activeIndex === 1} activatedProducts={true} awaitingProducts={false} cardName={'Activated Product'} />
          </div>
          <div style={{ position: 'relative' }} className=' col-3 my-1' onClick={() => onCardClick(2)}>
            <DashboardCard count={awatingCount} isActive={activeIndex === 2} activatedProducts={false} awaitingProducts={true} cardName={'Awaiting Result'} />
          </div>
          <div style={{ position: 'relative' }} className='col-3 my-1' onClick={() => onCardClick(3)}>
            <DashboardCard count={completeCount} isActive={activeIndex === 3} activatedProducts={false} awaitingProducts={false} cardName={'Completed'} />
          </div>
          <div style={{ position: 'relative' }} className='col-3 my-1' onClick={() => onCardClick(4)}>
            {/* <DashboardCard count={0} isActive={activeIndex === 4} activatedProducts={false} awaitingProducts={false} cardName={'Rejected'} /> */}
            <DashboardCard count={errorCount} isActive={activeIndex === 4} activatedProducts={false} awaitingProducts={false} cardName={'Result Errors'} />
          </div>
        </div>
        {/* <RadarChart reportData={reportData} /> */}
        {/* { activeIndex === 4 ? <di>No filters available for the selected section.</di> : <SearchBar onFinish={onSearchFinish} onFinishFailed={onSearchFinishFailed} searchItems={activeIndex === 1 ? ActivatedItem :  AwaitingItem } onChange={handleOnChange} />} */}
        <SearchBar
          isbarCode={true}
          serialvalue={serialvalue}
          disabled={isEncrypt}
          getSearchByValue={setSearchByValue}
          type={isEncrypt ? 'password' : ''}
          onFinish={onSearchFinish}
          onFinishFailed={onSearchFinishFailed}
          searchItems={activeIndex === 1 ? ActivatedItem : AwaitingItem}
          onChange={handleOnChange}
          activeIndex={activeIndex}
          setSearchShow={setSearchShow}
          setCurrentPage={setCurrentPage}
          isTestOrder={true}
          isFilter={true}
          setfilterObj={setfilterObj}
          showisFilter={showisFilter}
          setshowisFilter={setshowisFilter}
        />
        {loading && <LoaderImage />}

        <div className='table-scrollbar '>
          {tableHeaders.length > 0 && !loading ? (
            <table id='customers' className='w-100'>
              <thead className='w-100'>
                <tr>
                  {tableHeaders.map((header) => (
                    <th key={header}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {renderList.length > 0 ? (
                  renderList.map((output, index) => <tr key={index}>{activeIndex === 1 ? activatedProductRows(output) : activeIndex === 2 ? awaitngProductRows(output) : activeIndex === 3 ? completedProductRows(output) : errorListingRows(output)}</tr>)
                ) : (
                  <tr>
                    <td colSpan={tableHeaders.length} className='text-center'>
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          ) : (
            <>{!loading && <NoDataFound />}</>
          )}
        </div>
        {renderList.length > 0 && (
          <div className='row'>
            <Pagination style={{ marginBottom: '20px' }} onChange={onPageChange} defaultCurrent='1' current={currentPage} total={count} showTotal={(total) => `Total ${total} items`} showSizeChanger />

            {/* <Pagination style={{ marginBottom: '20px' }} onChange={onPageChange} defaultCurrent={currentPage} total={count} showTotal={(total) => `Total ${total} items`} showSizeChanger /> */}
          </div>
        )}
      </div>

      {/* <AntModal title='Test Report' open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
        <img src={logo} />
      </AntModal> */}
      <Modal size='md' show={isModalOpen} onHide={handleCancel}>
        <Modal.Header closeButton>
          <Modal.Title>Blood Work Cardiology</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='px-2'>
            <h3 className='mb-4'>
              <strong>Patient Info</strong>
            </h3>
            <div style={{ borderTop: '2px dotted #000', width: '50%', marginBottom: '1rem' }}></div>
            <h3 className='mb-4'>
              <strong>About this test report</strong>
            </h3>
            <div style={{ borderTop: '2px dotted #000', width: '50%', marginBottom: '1rem' }}></div>

            <h3 className='mb-4'>
              <strong>Complete Blood Count</strong>
            </h3>
            {reportData?.map((item) => (
              <Cardiology title={item.type} pointer={item.testValue} category={item.category} total={item.category[2].end} />
            ))}
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Order - Send To Lab</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {orderDetails ? (
            <div className='col-lg-12'>
              <Form
                initialValues={{
                  remember: true,
                  ['orderNo']: orderDetails.orderNo ? orderDetails.orderNo : '',
                  ['patientName']: orderDetails.patientName ? orderDetails.patientName : '',
                  ['mobile']: orderDetails.mobile ? orderDetails.mobile : '',
                  ['product']: orderDetails.productName ? orderDetails.productName : '',
                  ['serialNo']: orderDetails.serialNo ? orderDetails.serialNo : '',
                  ['sampleQuality']: orderDetails.quantity ? orderDetails.quantity : '',
                  ['status']: orderDetails.statusName ? orderDetails.statusName : '',
                  // ['sampleQuality']: orderDetails.quantity,?
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete='off'
              >
                <div className='row'>
                  <div className='col-lg-6'>
                    <label>
                      Order No. <span className='required-star'>*</span>
                    </label>
                    <Form.Item
                      name='orderNo'
                      defaultValue='1'
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: 'Enter Order Number',
                        },
                      ]}
                    >
                      <Input className='' placeholder='Enter Order Number' disabled />
                    </Form.Item>
                  </div>
                  <div className='col-lg-6'>
                    <label>
                      Customer <span className='required-star'>*</span>
                    </label>
                    <Form.Item
                      name='patientName'
                      defaultValue='1'
                      colon={false}
                      style={{ wordWrap: 'normal' }}
                      rules={[
                        {
                          required: true,
                          message: 'Enter Patient Name',
                        },
                      ]}
                    >
                      <Input placeholder='Enter Patient Name' disabled />
                    </Form.Item>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-lg-12'>
                    <label>
                      Mobile <span className='required-star'>*</span>
                    </label>
                    <Form.Item
                      name='mobile'
                      defaultValue='1'
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: 'Enter Mobile Number',
                        },
                      ]}
                    >
                      <InputMask mask='(999) 999-9999' onChange={handleChange} disabled>
                        {(inputProps) => <Input {...inputProps} placeholder='Enter Phone Number' style={{ width: '100% !important' }} disabled />}
                      </InputMask>
                    </Form.Item>
                  </div>
                  {/* <div className='col-lg-6'>
                    <Form.Item
                      name='status'
                      defaultValue='1'
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: 'Enter Email',
                        },
                      ]}
                    >
                      <Input placeholder='Enter Email' disabled />
                    </Form.Item>
                  </div> */}
                </div>
                <div className='row'>
                  <div className='col-lg-6'>
                    <label>
                      Product <span className='required-star'>*</span>
                    </label>
                    <Form.Item
                      colon={false}
                      name='product'
                      rules={[
                        {
                          required: true,
                          message: 'Enter product name',
                        },
                      ]}
                    >
                      <Input placeholder='Enter product name' className='admin' style={{ width: '100% !important' }} disabled />
                    </Form.Item>
                  </div>
                  <div className='col-lg-6'>
                    <label>
                      Serial No.<span className='required-star'>*</span>
                    </label>
                    <Form.Item
                      colon={false}
                      name='serialNo'
                      rules={[
                        {
                          required: true,
                          message: 'Enter Serial No',
                        },
                      ]}
                    >
                      <Input placeholder='Enter Serial No' className='admin' style={{ width: '100% !important' }} disabled />
                      {/* <InputMask mask='(999) 999-9999' onChange={handleChange}>
                    {(inputProps) => <Input {...inputProps} placeholder='Enter Phone Number' style={{ width: '100% !important' }} />} */}
                      {/* <Input /> */}
                      {/* </InputMask> */}
                      {/* <Input placeholder='Input Contact' /> */}
                    </Form.Item>
                  </div>
                </div>
                {/* <div className='row'>
                  <div className='col-lg-6'>
                    <Form.Item name='sampleQuality'>
                      <Input placeholder='Enter Sample Quality' className='admin' style={{ width: '100% !important' }} disabled />
                    </Form.Item>
                  </div>
                  <div className='col-lg-6'>
                    <Form.Item name='sampleQuality'>
                      <Input placeholder='Enter Sample Quality' className='admin' style={{ width: '100% !important' }} disabled />
                    </Form.Item>
                  </div>
                </div> */}
                <div className='col-lg-12'>
                  <label>Instructions</label>
                  <Form.Item name='instructions'>
                    <TextArea placeholder='Enter Instructions' className='admin' style={{ width: '100% !important' }} />
                  </Form.Item>
                </div>
                {/* <Row >
                  <Col>
                    <Form.Item label='Active' colon={false} valuePropName='checked' name='isActive'>
                      <Switch />
                    </Form.Item>
                  </Col>
                </Row> */}
                <div className='col-lg-12 text-center'>
                  <Button variant='success' className='dashboard col-lg-6 btn-style' htmlType='submit' onClick={() => submitData(orderDetails)}>
                    Send To Lab
                  </Button>
                </div>
              </Form>
            </div>
          ) : (
            ''
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button className='col-lg-2 btn-style' variant='secondary' onClick={handleClose}>
            Cancel
          </Button>
          {/* <Button variant='primary' htmlType='submit' onClick={submitData}>
            Save
          </Button> */}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Dashboard2;
